import Vue from 'vue'
import {
  Select,
  Option,
  Message,
  Dialog,
  Form,
  FormItem,
  Button,
  Autocomplete,
  Input
} from 'element-ui';
// Vue.use(ElementUI);
Vue.prototype.$message = Message;
Vue.use(Select);
Vue.use(Option);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Button);
Vue.use(Autocomplete);
Vue.use(Input);